import styled from 'styled-components';

const PrivacyPolicyTemplateStyle = styled.section`
	--ppTopBlockItemsGap: var(--sp2x);
	--datBlockPadding: var(--sp2x) var(--sp3x);
	--stickyItemPadding: var(--datBlockPadding);

	margin-bottom: var(--sectionDistance);

	.pp-top-block {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: space-between;
		gap: var(--ppTopBlockItemsGap);
	}

	.date-inner-block {
		padding: var(--datBlockPadding);
		background-color: var(--backgroundSecondaryColor);
		border-radius: var(--sp1x);
	}

	.pp-bottom-block {
		margin-top: var(--customDistance2);
	}

	.sticky-content {
		position: sticky;
		top: calc(var(--headerHeight) + var(--sectionDistance) / 2);
	}

	.content-block {
		&:not(:first-child) {
			margin-top: var(--customDistance2);
		}
	}

	.editor-wrapper {
		margin-top: var(--customDistance6);
	}

	.date-item {
		&:not(:first-child) {
			margin-top: var(--sp0-5x);
		}
	}

	.sticky-item {
		padding: var(--stickyItemPadding);
		background-color: var(--borderSecondaryColor);
		border-radius: var(--sp1x);

		&:not(:first-child) {
			margin-top: var(--gutter);
		}

		&.active {
			color: var(--hoverPrimaryColor);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--datBlockPadding: var(--sp1-5x) var(--sp2-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		.date-block {
			width: 100%;
			display: flex;
			justify-content: flex-end;
		}

		.date-inner-block {
			width: fit-content;
		}

		.sticky-panel {
			display: none;
		}
	}
`;

export default PrivacyPolicyTemplateStyle;
